import { LowerRegions } from "@/configs/region"
import { transactionData, TransactionData } from "./data"
type RegionConfig = {
  isShowLearnSection: boolean
  transactionContent: TransactionData
}
export const getRegionConfig = (region?: LowerRegions): RegionConfig => {
  const baseConfig = {
    isShowLearnSection: true,
    transactionContent: transactionData,
  }

  if (region === "kr") {
    const content = transactionData.filter(data => {
      if (data.name === "1:1 reserve") {
        data.isShowCTA = false
        data.descriptionKey = "section_two.contents_4_paragraph_kr"
      }
      return data.name !== "transaction"
    })
    return {
      ...baseConfig,
      transactionContent: content,
      isShowLearnSection: false,
    }
  }

  if (region === "eea") {
    const content = transactionData.filter(data => {
      if (data.name === "transaction") {
        data.titleKey = "section_two.contents_2_title_eea"
        data.descriptionKey = "section_two.contents_2_paragraph_eea"
      }
      return data
    })
    return {
      ...baseConfig,
      transactionContent: content,
    }
  }

  return baseConfig
}
